import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function Impressum({ language = "de" }) {
  const c = {
    de: {
      title: "Impressum",
      subtitle:
        "Offenlegung gemäß § 25 Mediengesetz und Informationen gemäß § 5 E-Commerce-Gesetz.",
      ownerLabel: "Medieninhaber, Herausgeber und Verleger",
      addressLabel: "Anschrift",
      contactLabel: "Kontakt",
      purposeLabel: "Tätigkeit",
      purpose:
        "Herausgabe eigener Buchtitel. Daneben Lektorat, Satz, Gestaltung und Übersetzung von Manuskripten für Dritte — ohne Veröffentlichung: Die Werke Dritter werden nicht verlegt.",
      directionLabel: "Grundlegende Richtung",
      direction:
        "Veröffentlichung eigener belletristischer Titel in spanischer und deutscher Sprache und Information über die Leistungen des Verlags. Die Website verfolgt keine parteipolitischen oder weltanschaulichen Zwecke.",
      responsibleLabel: "Für den Inhalt verantwortlich",
      isbnLabel: "ISBN-Verlagspräfix",
      hostingLabel: "Technische Umsetzung und Hosting",
      hosting: "Vercel Inc., USA. Näheres zur Datenverarbeitung in der",
      liabilityLabel: "Haftung für Links",
      liability:
        "Diese Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter verantwortlich.",
      copyrightLabel: "Urheberrecht",
      copyright:
        "Die Inhalte dieser Website, einschließlich Texten, Buchumschlägen und Illustrationen, sind urheberrechtlich geschützt. Eine Verwendung außerhalb der gesetzlich zugelassenen Fälle bedarf der vorherigen schriftlichen Zustimmung.",
      privacyLink: "Datenschutzerklärung",
      socialNote:
        "Dieses Impressum gilt auch für unsere Auftritte in sozialen Netzwerken.",
    },
    es: {
      title: "Aviso legal",
      subtitle:
        "Información conforme al § 25 de la Ley de Medios austriaca (Mediengesetz) y al § 5 de la Ley de Comercio Electrónico.",
      ownerLabel: "Titular del medio y editor",
      addressLabel: "Dirección",
      contactLabel: "Contacto",
      purposeLabel: "Actividad",
      purpose:
        "Publicación de los títulos propios de la editorial. Además, servicios de corrección, maquetación, diseño y traducción de manuscritos de terceros, que la editorial no publica: las obras ajenas no se editan bajo este sello.",
      directionLabel: "Orientación editorial",
      direction:
        "Publicación de narrativa propia en español y alemán e información sobre los servicios de la editorial. Este sitio no persigue fines partidistas ni ideológicos.",
      responsibleLabel: "Responsable del contenido",
      isbnLabel: "Prefijo ISBN de la editorial",
      hostingLabel: "Desarrollo y alojamiento",
      hosting:
        "Vercel Inc., EE. UU. El tratamiento de datos se detalla en la",
      liabilityLabel: "Enlaces externos",
      liability:
        "Este sitio contiene enlaces a páginas de terceros sobre cuyo contenido no tenemos influencia. La responsabilidad sobre esos contenidos corresponde siempre a su respectivo titular.",
      copyrightLabel: "Derechos de autor",
      copyright:
        "Los contenidos de este sitio, incluidos textos, cubiertas e ilustraciones, están protegidos por derechos de autor. Cualquier uso fuera de los casos permitidos por la ley requiere autorización previa por escrito.",
      privacyLink: "política de privacidad",
      socialNote:
        "Este aviso legal se aplica también a nuestros perfiles en redes sociales.",
    },
  }[language];

  const Bloque = ({ label, children }) => (
    <div className="py-4 border-b border-tinta/10 last:border-0">
      <div className="rotulo text-sombra mb-1.5">{label}</div>
      <div className="text-tinta/85">{children}</div>
    </div>
  );

  const enlace =
    "text-loboOscuro underline underline-offset-4 hover:text-tinta break-words";

  return (
    <div className="bg-papel text-tinta min-h-[70vh]">
      <div className="mx-auto max-w-3xl px-5 sm:px-8 py-16 sm:py-20">
        <Helmet>
          <title>{`${c.title} – Blauer Wolf Verlag`}</title>
          <meta name="robots" content="index, follow" />
        </Helmet>

        <h1 className="font-serif text-3xl sm:text-4xl tracking-titulo mb-4">
          {c.title}
        </h1>
        <p className="text-sombra mb-12">{c.subtitle}</p>

        <Bloque label={c.ownerLabel}>
          <p className="font-vers tracking-[0.1em]">Blauer Wolf Verlag</p>
          <p>César J. Cárdenas Lara</p>
        </Bloque>

        <Bloque label={c.addressLabel}>
          <p>Ober-Pabneukirchen 17</p>
          <p>4363 Pabneukirchen, Österreich / Austria</p>
        </Bloque>

        <Bloque label={c.contactLabel}>
          <a className={enlace} href="mailto:office@bw-verlag.at">
            office@bw-verlag.at
          </a>
          <br />
          <a className={enlace} href="https://www.bw-verlag.at">
            www.bw-verlag.at
          </a>
        </Bloque>

        <Bloque label={c.responsibleLabel}>César J. Cárdenas Lara</Bloque>

        <Bloque label={c.purposeLabel}>{c.purpose}</Bloque>

        <Bloque label={c.directionLabel}>{c.direction}</Bloque>

        <Bloque label={c.isbnLabel}>978-3-9505928</Bloque>

        <Bloque label={c.hostingLabel}>
          {c.hosting}{" "}
          <Link className={enlace} to={`/${language}/privacy`}>
            {c.privacyLink}
          </Link>
          .
        </Bloque>

        <Bloque label={c.liabilityLabel}>{c.liability}</Bloque>

        <Bloque label={c.copyrightLabel}>{c.copyright}</Bloque>

        <p className="mt-10 text-sm text-sombra">{c.socialNote}</p>
      </div>
    </div>
  );
}
